export class ApplicationTypes {
  static LOCKING = 'locking'
  static PASS = 'pass'
  static SHIP_CALL = 'ship_call'
  static SURVEY = 'survey'
}
